import {
  RESET,
  RESET_PART,
  SET_JERSEY_VIEW,
  SET_JERSEYS,
  SET_LOADING,
  SET_MORE,
  SET_NUMBERS,
  SET_PAGE,
  SET_SORT,
  SET_TOTAL,
  SET_TRACK,
  SET_VISIBILITY_MODAL,
} from './mutation-types';
import { getDefaultState } from './state';

export default {
  [RESET](state) {
    Object.assign(state, getDefaultState())
  },
  [RESET_PART](state,) {
    state.items = [];
    state.page = 0;
    state.pageLoaded = [];
  },
  [SET_JERSEY_VIEW](state, payload) {
    state.view = payload;
  },
  [SET_JERSEYS](state, payload) {
    Object.assign(state, payload);
  },
  [SET_LOADING](state, payload) {
    state.loading = payload;
  },
  [SET_MORE](state, payload) {
    state.more = payload;
  },
  [SET_NUMBERS](state, payload) {
    state.numbers = payload;
  },
  [SET_PAGE](state, payload) {
    state.page = payload;
  },
  [SET_SORT](state, payload) {
    state.options[payload.type] = payload.value;
  },
  [SET_TOTAL](state, payload) {
    state.total = payload;
  },
  [SET_TRACK](state, payload) {
    state.track = payload;
  },
  [SET_VISIBILITY_MODAL](state, payload) {
    state.visible = payload;
  },
};
